import { render, staticRenderFns } from "./PublicMeeting.vue?vue&type=template&id=b6c8d9fe&"
import script from "./PublicMeeting.vue?vue&type=script&lang=js&"
export * from "./PublicMeeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports